import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { getFeatureToColorMap } from "@teselagen/sequence-utils";
export const typeField = {
  path: "type",
  type: "string",
  render: (name, { color }) => {
    const colorToUse = color || getFeatureToColorMap({ includeHidden: true })[name];
    return /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [
      /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            height: 20,
            width: 20,
            background: colorToUse,
            marginRight: 3
          }
        }
      ),
      name
    ] });
  }
};
